<template>
  <div class="testView">
    <div class="newTitle">二维码测试</div>
    <vue-qr :text="config.value" :size="200" :margin="0"></vue-qr>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
export default {
  name: 'newsList',
  data () {
    return {
      msg: '二维码测试',
      config: {
        value: 'weixin://wxpay/bizpayurl?pr=1JZyCtV',
        imagePath: require('../../assets/icon/logo_w.png'),
        fillType: 'fill',
        version: 35,
        filter: 'threshold'
      },
      downloadButton: false,
      page: 0
    }
  },
  computed: {
  },
  mounted: function (s) {
    this.createQr()
  },
  methods: {
    createQr: function () {
    }
  },
  filters: {
  },
  components: {
    VueQr
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.testView {
  padding-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/test/testQrcode.vue